import React from 'react';
import UIComponent from './ui_component.js';
import javascriptTimeAgo from 'javascript-time-ago'

javascriptTimeAgo.locale(require('javascript-time-ago/locales/en'))
require('javascript-time-ago/intl-messageformat-global');
require('intl-messageformat/dist/locale-data/en')

class UIDate extends UIComponent { 
  constructor() {
    super();
    this.state = {
    }
  }

  getDefaults(){
    const defaults = {
      className : '',      
    }    
    return defaults;
  }  
  render() {
    const timeAgo = new javascriptTimeAgo('en-US');
    const twitter = timeAgo.style.twitter();
    var date;
    var str;
    try{
	    date = (!this.props.value || this.props.value === '' || this.props.value.length === 0) ? '' : (this.props.value instanceof Date) ? this.props.value : new Date(this.props.value);
	    str = (date === '') ? '' : timeAgo.format(date, twitter);
    } catch (ex){
  		str = this.props.value;
    }
    return (
      <span className={this.state.className}>{str}</span>
    );
  }
}


export default UIDate;


// WEBPACK FOOTER //
// ./src/core/ui/date.js